<template>
  <pricing-import
    class="everyday-pricing-import"
    formName="everyday-pricing-import"
    moduleSlug="everyday-pricing-import"
    controllerName="EverydayPricingImport.vue"
    moduleName="Everyday Pricing Import"
    priceTypeId="3"
  ></pricing-import>
</template>

<script>
import PricingImport from "./PricingImport.vue";
export default {
  name: "EverydayPricingImport",
  metaInfo() {
    return {
      title: `${this.$t("general.everyday-pricing-import")} | ${this.$t(
        "general.everyday-pricing"
      )} | ${this.$t("general.pricing-manager")}`,
    };
  },
  components: {
    PricingImport,
  },
};
</script>
